import React, { createContext, useContext, useRef, useState } from 'react';
import { Decrypt_Id_Name } from '@/Components/Common/Utility';
import { AddDeleteUpadate, fetchPostData } from '@/Components/hooks/Api';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [LoginAgencyID, setLoginAgencyID] = useState('');
  const [LoginPinID, setLoginPinID] = useState('');
  const [allowMultipleLogin, setAllowMultipleLogin] = useState(0);
  const [Is2FAEnabled, setIs2FAEnabled] = useState(false);
  const [loder, setLoder] = useState(false);

  const [authSession, setAuthSession] = useState({});
  const [isLogout, setIsLogout] = useState(false);
  const [logByOtp, setLogByOtp] = useState(false);
  const [forgetPasswordArray, setForgetPasswordArray] = useState([]);

  const getAuthSession = () => {
    const param = {
      Value: '',
      UniqueId: sessionStorage.getItem('UniqueUserID')
        ? Decrypt_Id_Name(sessionStorage.getItem('UniqueUserID'), 'UForUniqueUserID')
        : '',
      Key: JSON.stringify({ auth_token: '' }),
    };
    fetchPostData('LocalStorage/GetData_MultipleKeyLocalStorage', param).then((res) => {
      if (res?.length > 0) setAuthSession(res[0]);
    });
  };

  const [localStoreArray, setLocalStoreArray] = useState({});
  const [tokenArray, setTokenArray] = useState([]);
  const localStoreFetchRef = useRef({ uniqueId: null, inFlight: false });

  const getUniqueId = () =>
    sessionStorage.getItem('UniqueUserID')
      ? Decrypt_Id_Name(sessionStorage.getItem('UniqueUserID'), 'UForUniqueUserID')
      : '';

  const get_LocalStorage = () => {
    const uniqueValue = getUniqueId();
    if (!uniqueValue) return;

    const uniqueKey = String(uniqueValue);
    const hasData = localStoreArray && Object.keys(localStoreArray).length > 0;
    const isSame = localStoreFetchRef.current.uniqueId === uniqueKey;

    if (isSame && localStoreFetchRef.current.inFlight) return;
    if (isSame && hasData) return;

    localStoreFetchRef.current = { uniqueId: uniqueKey, inFlight: true };
    fetchPostData('LocalStorage/GetData_UniqueLocalStorage', { UniqueId: uniqueKey })
      .then((res) => {
        if (res) setLocalStoreArray(res[0]);
      })
      .finally(() => {
        localStoreFetchRef.current = { uniqueId: uniqueKey, inFlight: false };
      });
  };

  const get_LocalStorageToken = (localStoreObj) => {
    fetchPostData('LocalStorage/GetData_MultipleKeyLocalStorage', localStoreObj).then((res) => {
      if (res) setTokenArray(res[0]);
    });
  };

  const deleteStoreData = async (LocalStoreObj) => {
    Object.keys(LocalStoreObj).forEach((prop) => delete localStoreArray[prop]);
    const val = {
      Value: '',
      UniqueId: getUniqueId(),
      Key: JSON.stringify(LocalStoreObj),
    };
    AddDeleteUpadate('LocalStorage/DeleteLocalStorageWithKey', val);
  };

  const storeData = (LocalStoreObj) => {
    const val = {
      Value: '',
      UniqueId: getUniqueId(),
      Key: JSON.stringify(LocalStoreObj),
    };
    AddDeleteUpadate('LocalStorage/ObjectInsert_LocalStorage', val);
  };

  const [ws, setWs] = useState(null);

  return (
    <AuthContext.Provider
      value={{
        LoginAgencyID,
        setLoginAgencyID,
        LoginPinID,
        setLoginPinID,
        allowMultipleLogin,
        setAllowMultipleLogin,
        Is2FAEnabled,
        setIs2FAEnabled,
        loder,
        setLoder,
        authSession,
        setAuthSession,
        getAuthSession,
        isLogout,
        setIsLogout,
        logByOtp,
        setLogByOtp,
        forgetPasswordArray,
        setForgetPasswordArray,
        localStoreArray,
        setLocalStoreArray,
        tokenArray,
        setTokenArray,
        get_LocalStorage,
        get_LocalStorageToken,
        deleteStoreData,
        storeData,
        ws,
        setWs,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
};

export default AuthContext;
